import {Component, store, constant} from 'Generic';
import {DEDICATED_IP_ICON, addonIconMap} from 'Generic/constants/addonIcons';
import {getTranslation, addCurrencySymbol, numberFormat} from 'Generic/lib';

export default class PopularAddons extends Component {
  constructor() {
    super({
      store,
      element: document.querySelector('#popular-addons-box'),
      state: store.state,
    });
  }

  render() {
    const selectedPlan = this.state.selected_plan || {};
    const addonList = selectedPlan.addons || [];
    const selectedAddons = this.state.selected_addons ? this.state.selected_addons : [];
    const disabledAddons = this.state.disable_addons ? this.state.disable_addons : [];
    const currencyCode = this.state.currency_code;
    const oldAddonPrices = this.state.old_prices?.[currencyCode] || {};
    const PopularAddonWrapper = this.element;

    const {DEDICATED_IP, PORT_FORWARDING_DEDICATED_IP, addonWithExtraMonth} = constant || {};
    const order = [PORT_FORWARDING_DEDICATED_IP, DEDICATED_IP];

    let popularAddons = addonList.filter(addon => order.includes(addon.code));

    popularAddons = popularAddons.sort((a, b) => {
      return order.indexOf(a.code) - order.indexOf(b.code);
    });

    const PopularAddonbox = PopularAddonWrapper.querySelector('#pop-addons-wrapper');
    if (popularAddons.length && PopularAddonbox) {
      PopularAddonbox.innerHTML = popularAddons
        .map(addon => {
          const icon = addonIconMap[addon.code] || DEDICATED_IP_ICON;
          const title = getTranslation(addon.code);
          const effectiveMonths = addonWithExtraMonth.includes(addon.code) ? selectedPlan.months : selectedPlan.interval_length;
          const monthlyPrice = Number(addon.unit_amount) / Number(effectiveMonths);
          const oldPrice = oldAddonPrices[addon.code] ? Number(oldAddonPrices[addon.code]) : 0;
          const showCutPrice = oldPrice > monthlyPrice;
          const discountPercentage = showCutPrice
            ? `${getTranslation('addon_saving_label')} ${Math.round((1 - monthlyPrice / oldPrice) * 100)}%`
            : '';

          return `
        <div class="pop-addon__item ${disabledAddons.includes(addon.code) ? 'disabled-box' : ''}" addon-code="${addon.code}">
      <div class="pop-addon__section pop-addon__section--left"> 
      <div class="pop-addon-box">
      <span>${icon}</span>
      <span class="pop-addon__title">${title}</span>
      </div>
      <div class="pop-addon__plan">
        <span>${getTranslation(selectedPlan.billing_cycle)}</span>
        <span class="pop-addon__saving"> ${discountPercentage} </span>
      </div>
      <div class="pop-addon__desc">${getTranslation(`${addon.code}_pop_des`)}</div>
    </div>

    <div class="pop-addon__section pop-addon__section--middle">
      <div class="pop-addon__price">${addCurrencySymbol(numberFormat(monthlyPrice))}/${getTranslation('mo')}</div>
      <div class="pop-addon__old-price ${!showCutPrice ? 'hidden' : ''}">${showCutPrice ? addCurrencySymbol(numberFormat(oldPrice)) : ''}</div> 
    </div>

    <div class="pop-addon__section pop-addon__section--right">
      <button type="button" class="addon-btn pop-addon__add-btn" addon-code="${addon.code}"
        ${selectedAddons.includes(addon.code) ? "style='display:none;'" : ''}
        ${
          disabledAddons.includes(addon.code) ? 'disabled' : ''
        }  data-origin="popular-addons" data-eventname="cro_popular_addon_click"  data-eventparamkey="position|element_text"  data-eventparamvalue="popular_addon_box|${
            addon.code
          }">

        <span class="addon-name">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
            <rect width="21" height="21" rx="4.375" fill="#581BBA"/>
            <path d="M10.5625 5.25C11.1493 5.25 11.6249 5.72568 11.625 6.3125V9.5H14.8145C15.4012 9.50013 15.877 9.97568 15.877 10.5625C15.877 11.1493 15.4012 11.6249 14.8145 11.625H11.625V14.8145C11.6249 15.4012 11.1493 15.877 10.5625 15.877C9.97576 15.8769 9.50013 15.4012 9.5 14.8145V11.625H6.3125C5.72568 11.6249 5.25 11.1493 5.25 10.5625C5.25 9.97566 5.72568 9.5001 6.3125 9.5H9.5V6.3125C9.5001 5.72574 9.97574 5.2501 10.5625 5.25Z" fill="white"/>
            </svg>
          </span>
      </button>

      <button type="button" class="remove-btn addon-btn" addon-code="${addon.code}"
         ${selectedAddons.includes(addon.code) ? "style='display:inline-block;'" : "style='display:none;'"}>

          <span class="addon-name">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
              <rect width="21" height="21" rx="4.375" fill="#581BBA"/>
              <rect x="5" y="9.5" width="11" height="2" rx="1" fill="white"/>
            </svg>
          </span>
        </button>
    </div>
  </div>
    `;
        })
        .join('');
    }
  }
}
